import { Link } from '@inertiajs/react';

interface Tag {
  id: number;
  name: string;
  slug: string;
  product_count?: number;
  url: string;
}

interface TagsListProps {
  tags: Tag[];
  title?: string;
  showCount?: boolean;
  className?: string;
}

export default function TagsList({
  tags,
  title = 'Tags',
  showCount = true,
  className = '',
}: TagsListProps) {
  return (
    <div className={`${className}`}>
      {title && (
        <h2 className="text-2xl font-semibold text-base-content mb-4">
          {title}
        </h2>
      )}
      <div className="flex flex-wrap gap-2">
        {tags.map(tag => (
          <Link
            key={tag.id}
            href={tag.url}
            className="inline-flex items-center space-x-2 px-3 py-1 text-sm font-semibold rounded-full bg-green-100 text-green-800 hover:bg-green-200 transition-colors"
          >
            <span>{tag.name}</span>
            {showCount && (
              <span className="text-xs text-green-700">
                ({tag.product_count})
              </span>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
